import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SpecialRoutingService {
  constructor(private router: Router) {}

  prepareRoute(route: string, slug?: string, id?: number, echelon?: string|null, compare_ids?:number[]|string[]) {
    let params:any = {}
    
    if (slug) {
      params['slug'] = slug
    } 
    if (id) {
      params['id'] = id
    }
    if (echelon) {
      params['echelon'] = echelon
    }
    if (compare_ids) {
      params['compare'] = compare_ids.join('-');
    }

    if (Object.keys(params).length === 0) { //Added just in case it *needs* to be null
      params = null
    }

    return {path:route, queryParams: params}
  }

  redirectToRoute(route: { path: string; queryParams?: any }) {
    if (route.queryParams) {
      this.router.navigate([route.path], { queryParams: route.queryParams });
      window.scrollTo(0, 0);
    } else {
      this.router.navigate([route.path]);
      window.scrollTo(0, 0);
    }
  }

  redirectToRAAPath(route: { path: string; queryParams?: any }) {
    // Remove trailing slash from base URL if it exists
    const baseUrl = environment.raa.frontend_base.endsWith('/')
      ? environment.raa.frontend_base.slice(0, -1)
      : environment.raa.frontend_base;

    // Construct the full URL
    let url = `${baseUrl}${route.path}`;

    // Add query parameters if they exist
    if (route.queryParams) {
      const queryParams = new URLSearchParams(route.queryParams).toString();
      url += `?${queryParams}`;
    }

    window.scrollTo(0, 0);
    // Redirect to the constructed URL
    window.location.href = url;
  }


  redirectToMRAPath(route: { path: string; queryParams?: any }) {
    // Remove trailing slash from base URL if it exists
    const baseUrl = environment.mra.frontend_base.endsWith('/')
      ? environment.mra.frontend_base.slice(0, -1)
      : environment.mra.frontend_base;

    // Construct the full URL
    let url = `${baseUrl}${route.path}`;

    // Add query parameters if they exist
    if (route.queryParams) {
      const queryParams = new URLSearchParams(route.queryParams).toString();
      url += `?${queryParams}`;
    }

    window.scrollTo(0, 0);

    // Open the constructed URL in a new tab
    window.open(url, '_blank');
  }
}
